import { RenderElementProps } from 'slate-react';

export const ELEMENT_IELTS_PURPOSE_CONVERTER = 'ielts-purpose-converter';

export interface IeltsPurposeConverterPluginOptions {
  isReadOnly?: boolean;
}
export interface IeltsPurposeConverterElementProps
  extends RenderElementProps,
    IeltsPurposeConverterPluginOptions {}
